(() => {
  'use strict';
  // Tag changes use real Shopify navigation; native option/price facets keep their AJAX path.
  const decode = (value) => { try { return decodeURIComponent(value); } catch { return value; } };
  // Exact consumer dictionary: labels are not source evidence or newly assigned product facts.
  const dictionary = {
    finish: 'cs-finish-polished::Lucios|cs-finish-textured::Texturat',
    stone: 'cs-stone-lab-grown-diamond::Cu diamante de laborator|cs-stone-none::Fără diamante',
    purchase: 'cs-sold-as-pair::Modele de pereche|cs-sold-as-single::Verighete individuale',
    type: 'cs-earring-type-stud::Cercei mici|cs-earring-type-hoop::Cercuri|cs-earring-type-drop::Pendulanți|cs-earring-type-cluster::Cluster|cs-earring-type-ear-jacket::Ear jacket|cs-wedding-subtype-eternity::Eternity|cs-wedding-subtype-half-eternity::Semi-eternity|cs-wedding-subtype-diamond-band::Bandă cu diamante|cs-wedding-subtype-statement-band::Bandă statement|cs-bracelet-style-tennis::Tennis|cs-bracelet-style-bangle::Rigidă|cs-bracelet-style-chain::Lanț|cs-bracelet-style-link::Zale',
    style: 'cs-style-solitaire::Solitaire|cs-style-halo::Halo|cs-style-three-stone::Trei pietre|cs-style-toi-et-moi::Toi et Moi|cs-style-sculptural::Sculptural|cs-model-primary-cluster::Cluster|cs-model-primary-five-stone::Cinci pietre|cs-earring-style-solitaire::Solitaire|cs-earring-style-halo::Halo|cs-earring-style-cluster::Cluster|cs-earring-style-geometric::Geometric|cs-earring-style-drop::Pendulant|cs-earring-style-chandelier::Candelabru|cs-earring-style-hoop::Cercuri|cs-earring-style-chain::Lanț|cs-earring-style-ear-jacket::Ear jacket|cs-earring-style-sculptural::Sculptural|cs-earring-style-graduated::Gradat|cs-earring-style-linear::Liniar|cs-style-classic::Clasic|cs-style-minimalist::Minimalist|cs-style-modern::Modern|cs-style-geometric::Geometric|cs-style-romantic::Romantic|cs-style-vintage::Vintage|cs-style-floral::Floral|cs-style-filigree::Filigran|cs-style-lattice::Model de rețea|cs-style-link::Model de zale|cs-style-open-geometric::Geometric ajurat|cs-style-panelled::Model cu panouri|cs-style-grooved::Cu caneluri|cs-style-bezel::Piatră încastrată',
    shape: 'cs-shape-round::Rotundă|cs-shape-oval::Ovală|cs-shape-pear::Pară|cs-shape-emerald::Emerald (tăietură)|cs-shape-marquise::Marquise|cs-shape-cushion::Cushion|cs-shape-radiant::Radiant|cs-shape-princess::Princess|cs-shape-asscher::Asscher|cs-shape-heart::Inimă|cs-shape-baguette::Baguette|cs-shape-triangle::Triunghi|cs-shape-mixed::Forme mixte',
    profile: 'cs-bracelet-profile-flexible::Flexibilă|cs-bracelet-profile-rigid::Rigidă|cs-bracelet-profile-articulated::Articulată|cs-profile-flat::Plat|cs-profile-domed::Bombat|cs-profile-grooved::Cu caneluri|cs-profile-faceted::Fațetat|cs-profile-beveled::Cu margini teșite|cs-profile-curved::Curbat|cs-profile-tapered::Îngustat treptat|cs-profile-sculpted::Sculptat|cs-profile-segmented::Segmentat|cs-profile-bypass::Cu linii petrecute',
    motif: 'cs-motif-heart::Inimă|cs-motif-floral::Floral|cs-motif-trefoil::Trifoi|cs-motif-butterfly::Fluture|cs-motif-botanical::Botanic|cs-motif-open-teardrop::Picătură ajurată',
    selection: 'cs-selection-forever-17::Forever 17',
  };
  const known = new Map(Object.entries(dictionary).flatMap(([group, entries]) => entries.split('|').map(entry => {
    const [slug, label] = entry.split('::'); return [slug, { group, label }];
  })));
  // Retired unqualified palette facet stays removable; do not restate it as a diamond claim.
  known.set('cs-palette-white', { group: 'legacy', label: 'Selecție anterioară' });
  function state(href) {
    const url = new URL(href);
    const match = url.pathname.match(/^(.*\/collections\/[^/]+)(?:\/([^/]+))?\/?$/);
    if (!match) return null;
    return { url, base: match[1], tags: [...new Set((match[2] || '').split('+').filter(Boolean).map(decode))] };
  }
  function route(href, { toggle, remove, clearDimension, clearTags = false, clearAll = false } = {}) {
    const current = state(href);
    if (!current) return href;
    let tags = clearTags || clearAll ? [] : current.tags.slice();
    if (clearDimension) tags = tags.filter(tag => known.get(tag)?.group !== clearDimension);
    if (toggle) {
      const group = known.get(toggle)?.group;
      tags = tags.includes(toggle) ? tags.filter(tag => tag !== toggle) : [...tags.filter(tag => !group || known.get(tag)?.group !== group), toggle];
    }
    if (remove) tags = tags.filter((tag) => tag !== remove);
    current.url.pathname = current.base + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '');
    for (const key of [...current.url.searchParams.keys()]) {
      if (key === 'page' || key === 'section_id' || key === 'sections' || (clearAll && key.startsWith('filter.'))) current.url.searchParams.delete(key);
    }
    current.url.hash = '';
    return current.url.pathname + current.url.search;
  }
  function preserveQuery(href, nextQuery) {
    const current = new URL(href).searchParams;
    const next = new URLSearchParams(nextQuery);
    for (const [key, value] of current) {
      if (!key.startsWith('filter.') && !['page', 'section_id', 'sections'].includes(key) && !next.has(key)) next.append(key, value);
    }
    for (const key of ['page', 'section_id', 'sections']) next.delete(key);
    // Empty price controls are not active filters; do not leave phantom chips/history entries.
    for (const [key, value] of [...next]) if (key.startsWith('filter.') && value === '') next.delete(key);
    return next.toString();
  }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function sync(root) {
    const current = state(window.location.href);
    if (!current) return;
    const labels = new Map([...known].map(([slug, value]) => [slug, value.label]));
    const links = [...root.querySelectorAll('[data-cs-constraint-tag]')];
    for (const link of links) {
      if (!link.dataset.csConstraintHref) link.dataset.csConstraintHref = link.getAttribute('href') || '';
      const original = new URL(link.dataset.csConstraintHref, window.location.href);
      const slug = link.dataset.csConstraintSlug || decode(original.pathname.split('/').filter(Boolean).pop() || '');
      if (!slug || slug.includes('+')) continue;
      labels.set(slug, link.dataset.csConstraintLabel || slug);
      const selected = current.tags.includes(slug);
      link.classList.toggle('is-active', selected);
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
      link.href = route(window.location.href, { toggle: slug });
      if (link.hasAttribute('data-cs-tag-facet')) {
        link.classList.toggle('active', selected);
        link.setAttribute('aria-label', `${selected ? 'Elimină' : 'Alege'} filtrul ${labels.get(slug)}`);
        link.querySelector('[data-cs-tag-check]')?.setAttribute('visibility', selected ? 'visible' : 'hidden');
      }
    }
    for (const group of root.querySelectorAll('[data-cs-tag-group]')) {
      const selected = current.tags.filter(tag => known.get(tag)?.group === group.dataset.csTagGroup);
      const summary = group.querySelector('[data-cs-tag-selection]');
      text(summary, selected.map(tag => labels.get(tag)).join(' · '));
      if (summary) summary.hidden = selected.length === 0;
      const clear = group.querySelector('[data-cs-group-clear]');
      if (clear) {
        clear.hidden = selected.length === 0;
        clear.href = route(window.location.href, { clearDimension: group.dataset.csTagGroup });
      }
    }
    for (const link of root.querySelectorAll('[data-cs-constraint-clear]')) {
      link.href = route(window.location.href, { clearTags: true });
      link.classList.toggle('is-active', current.tags.length === 0);
      if (current.tags.length) link.removeAttribute('aria-current');
      else link.setAttribute('aria-current', 'page');
    }
    root.querySelectorAll('input[data-cs-constraint-field]').forEach((input) => input.remove());
    const region = root.querySelector('[data-cs-filter-tokens]');
    const tokens = [...(region?.querySelectorAll('[data-cs-constraint-token]') || [])];
    const template = tokens[0];
    if (template) {
      while (tokens.length > Math.max(1, current.tags.length)) tokens.pop().remove();
      while (tokens.length < current.tags.length) {
        const token = template.cloneNode(true);
        tokens.at(-1).after(token);
        tokens.push(token);
      }
      tokens.forEach((token, index) => {
        const slug = current.tags[index];
        const label = slug ? labels.get(slug) || 'Selecție suplimentară' : '';
        token.hidden = !slug;
        token.href = route(window.location.href, { remove: slug });
        text(token.querySelector('[data-cs-constraint-token-label]'), label);
        text(token.querySelector('[data-cs-constraint-token-remove-label]'), `Elimină selecția ${label}`);
      });
    }
    const nativeCount = region?.querySelectorAll('[data-cs-native-filter-token]').length || 0;
    const hasNativeFilter = [...current.url.searchParams].some(([key, value]) => key.startsWith('filter.') && value !== '');
    const active = current.tags.length > 0 || nativeCount > 0 || hasNativeFilter;
    if (region) region.hidden = !active;
    for (const link of root.querySelectorAll('[data-cs-clear-all]')) {
      link.href = route(window.location.href, { clearAll: true });
      if (link.closest('[data-cs-filter-tokens]')) link.hidden = !active;
    }
  }
  window.CorsailleCollectionTagFilters = { sync, route, state, preserveQuery };
})();
